import React from "react";

// Theme toggle hidden while light mode is disabled. Kept as a null-render
// component so every existing `<ThemeToggle />` mount site stays valid.
export const ThemeToggle = () => null;
export default ThemeToggle;
